form {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.screenCardWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    flex: 1;
    overflow-y: auto;
  }

  .footerWrapper {
    .footer {
      display: flex;
      justify-content: flex-end;
      padding-top: var(--fly-number-spacing-6);
      gap: var(--fly-number-spacing-3);
    }
  }
}
